import React from "react";

type Props = React.SVGProps<SVGSVGElement> & {
    title?: string;
};

const FacebookIcon = ({ title, ...props }: Props) => {
    return (
        <svg
            {...props}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label={title}
        >
            {title && <title>{title}</title>}
            <path
                d="M16 0.0968018C7.1632 0.0968018 0 7.26 0 16.0968C0 24.0824 5.8512 30.7016 13.5008 31.9032V20.7208H9.4368V16.0968H13.5008V12.572C13.5008 8.5624 15.888 6.348 19.544 6.348C21.2944 6.348 23.1248 6.66 23.1248 6.66V10.596H21.1088C19.12 10.596 18.5008 11.8296 18.5008 13.0952V16.0968H22.9376L22.2288 20.7208H18.5008V31.9032C26.1488 30.7032 32 24.0808 32 16.0968C32 7.26 24.8368 0.0968018 16 0.0968018Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default FacebookIcon;
